import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  fetchVesselList,
  updateVesselData,
  deleteVesselData,
  addVesselData,
} from "../../apis/vessels";

export const fetchVesselListData = createAsyncThunk(
  "vesselList/fetchVesselList",
  async (_, { rejectWithValue }) => {
    try {
      const vesselList = await fetchVesselList();
      return vesselList.data;
    } catch (error: any) {
      console.log("error->", error);
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const state = getState() as any; // Replace 'any' with your RootState type
      return !state.vesselList.isDataFetched; // Adjust path based on your state structure
    },
  }
);

export const updateVessel = createAsyncThunk(
  "VesselList/updateVessel",
  async (
    {
      vessel_id,
      data,
    }: {
      vessel_id: string;
      data: {
        [key: string]: any;
        vessel_id: string;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const result = await updateVesselData(vessel_id, data);
      return result.data;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const deleteVessel = createAsyncThunk(
  "vesselList/deleteVessel",
  async (
    {
      vessel_id,
    }: {
      vessel_id: string;
    },
    { rejectWithValue }
  ) => {
    try {
      await deleteVesselData(vessel_id);
      return vessel_id;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);

export const addNewVesselData = createAsyncThunk(
  "VesselList/deleteVesselData",
  async (
    {
      data,
    }: {
      data: {
        [key: string]: any;
      };
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await addVesselData(data);
      return response;
    } catch (error: any) {
      console.log(error);
      return rejectWithValue(error.message);
    }
  }
);
